const DEFAULT_APP_FONT_SIZE_PT = 11;
export const MIN_APP_FONT_SIZE_PT = 9;
export const MAX_APP_FONT_SIZE_PT = 16;
export const APP_FONT_SIZE_PT_STEP = 0.5;

const LEGACY_APP_FONT_SIZE_PERCENT_BASE_PT = 11;

const isFiniteNumber = (value: number): boolean => {
	return Number.isFinite(value);
};

const roundAppFontSizePt = (value: number): number => {
	const roundedValue = Math.round(value / APP_FONT_SIZE_PT_STEP) * APP_FONT_SIZE_PT_STEP;
	return Number(roundedValue.toFixed(1));
};

export const clampAppFontSizePt = (value: number): number => {
	if (!isFiniteNumber(value)) {
		return DEFAULT_APP_FONT_SIZE_PT;
	}

	return Math.min(MAX_APP_FONT_SIZE_PT, Math.max(MIN_APP_FONT_SIZE_PT, roundAppFontSizePt(value)));
};

const convertLegacyPercentToPointSize = (legacyPercentValue: string): number => {
	const parsedPercentValue = Number.parseInt(legacyPercentValue, 10);
	if (!isFiniteNumber(parsedPercentValue)) {
		return DEFAULT_APP_FONT_SIZE_PT;
	}

	return clampAppFontSizePt((LEGACY_APP_FONT_SIZE_PERCENT_BASE_PT * parsedPercentValue) / 100);
};

export const resolveStoredAppFontSizePt = (
	storedPointSizeValue: null | string,
	storedLegacyPercentValue?: null | string
): number => {
	if (storedPointSizeValue !== null) {
		const parsedPointSizeValue = Number.parseFloat(storedPointSizeValue);
		return clampAppFontSizePt(parsedPointSizeValue);
	}

	if (storedLegacyPercentValue !== undefined && storedLegacyPercentValue !== null) {
		return convertLegacyPercentToPointSize(storedLegacyPercentValue);
	}

	return DEFAULT_APP_FONT_SIZE_PT;
};

export const applyAppFontSizePt = (appFontSizePt: number): void => {
	if (typeof document === 'undefined' || document.documentElement === undefined) {
		return;
	}

	const clampedFontSizePt = clampAppFontSizePt(appFontSizePt);
	document.documentElement.style.fontSize = `${clampedFontSizePt}pt`;

	if (document.body !== null && document.body.style !== undefined) {
		document.body.style.fontSize = 'inherit';
	}
};
